module.exports = __webpack_public_path__ + "static/media/komf4.e63ed5d5.jpg";